// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
// load (Polyfill) EventSource, in case browser does not support it...
import 'babel-polyfill';

import Vue from 'vue';
import axios from 'axios';
import VueAxios from 'vue-axios';
import moment from 'moment';

import BootstrapVue from 'bootstrap-vue';
import App from './App';
import router from './router';
import store from './store';
import VModal from 'vue-js-modal';
import VeeValidate from 'vee-validate';
import * as VueGoogleMaps from 'vue2-google-maps';
import VueToastr from '@deveodk/vue-toastr';
import VueAnalytics, { onAnalyticsReady } from 'vue-analytics';
import PrettyCheckbox from 'pretty-checkbox-vue';
import PrettyRadio from 'pretty-checkbox-vue/radio';
import VueSweetalert2 from 'vue-sweetalert2';
import Auth from '@aws-amplify/auth';

// import CKEditor from 'ckeditor';
// You need a specific loader for CSS files like https://github.com/webpack/css-loader
// If you would like custom styling of the toastr the css file can be replaced
import '@deveodk/vue-toastr/dist/@deveodk/vue-toastr.css'

import 'bootstrap-vue/dist/bootstrap-vue.css';
import 'bootstrap/dist/css/bootstrap.css';
import '../static/css/style.css';
import './styles/customstyle.less';
import 'vue-multiselect/dist/vue-multiselect.min.css';
import 'izitoast/dist/css/iziToast.min.css';
import iziToastOptions from './utils/izi-toast';
import VueIziToast from './plugins/VueIziToast';
import emailTemplateConsts from '@/store/constants/emailTemplateType';
import ScrollLoader from 'vue-scroll-loader';
// import './utils/bing-map-api-helper';

Vue.use(VModal, { dialog: true });
// Vue.use(CKEditor);
Vue.use(PrettyRadio);
Vue.use(VueAxios, axios);
Vue.use(BootstrapVue);
Vue.use(VeeValidate);
Vue.use(VueToastr, {
  defaultPosition: 'toast-top-right',
  defaultType: 'success',
  defaultTimeout: 2000
});

Vue.use(VueIziToast, {
  progressBar: false,
  position: 'topRight',
  animateInside: false,
  overlayColor: 'rgba(0, 0, 0, 0.3)',
  drag: false,
  messageColor: '#fff'
});

Auth.configure({
  userPoolId: process.env.COGNITO.userPoolId,
  userPoolWebClientId: process.env.COGNITO.userPoolWebClientId,
  oauth: process.env.COGNITO.oauth
});

Vue.use(ScrollLoader);
Vue.use(VueGoogleMaps);
Vue.use(PrettyCheckbox);
Vue.use(VueSweetalert2);
Vue.config.productionTip = false;
Vue.config.silent = true;
Vue.use(VueAnalytics, {
  id: 'UA-116747746-1',
  router,
  autoTracking: {
    pageViewOnLoad: true
  }
});

Vue.filter('date', date => moment(date).format('yyyy-MM-dd'));
Vue.filter('dateFormatMMDDYY', date => moment(date).format('MM/DD/YYYY'));
Vue.filter('dateFormatMMMM', date => moment(date, 'MM/DD/YYYY').format('MMMM D YYYY'));
Vue.filter('templateName', value => {
  let result = '';
  switch (value) {
    case emailTemplateConsts.day30:
      result = '30 Day Reminder';
      break;
    case emailTemplateConsts.day60:
      result = '60 Day Reminder';
      break;
    case emailTemplateConsts.day7:
      result = 'Tracking';
      break;
    case emailTemplateConsts.thankyou:
      result = 'Thank You';
      break;
    case emailTemplateConsts.tracking:
      result = 'Tracking';
      break;
    case emailTemplateConsts.eventConfirmation:
      result = 'Event Confirmation';
      break;
    case emailTemplateConsts.notReminded:
      result = 'No Email Sent';
      break;
    case emailTemplateConsts.cancellation:
      result = 'Cancellation';
      break;
    default:
      break;
  }
  return result;
});

Vue.prototype.$bus = new Vue();
Vue.prototype.$toastOpt = iziToastOptions;
let url = 'https://www.bing.com/api/maps/mapcontrol?key=' + process.env.BING_MAP_KEY;
Vue.loadScript(url);

/* eslint-disable no-new */
onAnalyticsReady().then(() => {
  new Vue({
    el: '#app',
    router,
    template: '<App/>',
    components: {App},
    store
  });
});

function addCkPlugin () {
  window.CKEDITOR.plugins.add('eventTags', {
    requires: ['richcombo'], // , 'styles' ],
    init: function (editor) {
      window.CKEDITOR.dtd.$removeEmpty['span'] = true;
      let config = editor.config;
      // let lang = editor.lang.format;

      // Gets the list of tags from the settings.
      let tags = config.emailTags; // new Array();

      // Create style objects for all defined styles.
      function styleItem (color) {
        // style to display on dropdown list
        return '<span style="">' + color + '</span>';
      }

      let acfRules = 'span{color}';

      editor.ui.addRichCombo('eventTags', {
        label: 'Insert Field',
        title: 'Insert Field',
        voiceLabel: 'Insert Field',
        className: 'cke_format',
        multiSelect: false,
        allowedContent: acfRules,
        requiredContent: acfRules,
        panel:
          {
            css: [window.CKEDITOR.skin.getPath('editor')].concat(config.contentsCss),
            multiSelect: false
          },

        init: function () {
          this.startGroup('Insert Field');
          // show tags to drop down
          for (let thisTag in tags) {
            if (tags[thisTag].name === '[survey_bio_result_url]') {
              let tagFormat = '<span class="email-tag" contenteditable="false"><a href="tag_name" contenteditable="false" style="cursor: pointer; text-decoration: underline;">tag_name</a></span>';
              this.add(tagFormat.replace(/tag_name/g, tags[thisTag].name), styleItem(tags[thisTag].description), tags[thisTag].description);
            } else {
              let tagFormat = '<span class="email-tag" contenteditable="false">tag_name</span>';
              this.add(tagFormat.replace('tag_name', tags[thisTag].name), styleItem(tags[thisTag].description), tags[thisTag].description);
            }
          }
        },
        onClick: function (value) {
          editor.focus();
          editor.fire('saveSnapshot');
          let newElement = window.CKEDITOR.dom.element.createFromHtml(value, editor.document);
          editor.insertElement(newElement);
          editor.fire('saveSnapshot');
        }
      });
    }
  });
};

addCkPlugin();



// WEBPACK FOOTER //
// ./src/main.js